/**
 * Style Advisor service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxUrlChatSvc', ItxUrlChatSvc);

    ItxUrlChatSvc.$inject = ['timestampSvc'];

    function ItxUrlChatSvc(timestampSvc) {
        var _this = this;

        var service = {
            initWidget: _initWidget
        };

        return service;

        /**
         * Función para inyectar el widget en la web
         */
        function _initWidget(config) {
            var styleFileName = 'chatbot.css?t=' + timestampSvc.getTs();
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');

            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.as = 'style';
            link.href = window.staticContent + '/itxwebstandard/css/' + styleFileName;

            head.appendChild(link);
        }
    }
})();
